<template>
  <section class="section full-height">
    <admin-section-header icon="view-grid" title="Contabilidad" />
    <div class="tile is-ancestor full-width is-vertical height-100">
      <div class="tile is-parent is-horizontal">
        <dashboard-banner-tile
          :title="$t('Contabilidad')"
          subtitle=""
          :ctaText="$t('Acceder')"
          ctaTarget="https://akaunting.com/es/planes"
          backgroundImage="https://assets.akaunting.com/site/img/pages/home/akaunting-dashboard.png"
        ></dashboard-banner-tile>
      </div>
    </div>
  </section>
</template>

<script>
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'
export default {
  name: 'Accounting',
  components: {
    AdminSectionHeader,
    DashboardBannerTile
  },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Contabilidad'],
      title: 'Contabilidad'
    })
  }
}
</script>

<style lang="scss" scoped>
button.is-large {
  width: max-content;
  height: max-content;
}
.button-grid button {
  margin: 10px 10px;
  border-color: var(--rosa-dark-eco);
}
</style>
